import m from "mithril";
import RootTemplate from "./templates/root-template.jsx";

const Home = {
  view: () => {
    return (
      <RootTemplate>
        <section>
          <p>
            &emsp; This project is called <b>vm-kit</b>. Without the many
            details and quite simply; You can consider this the linux kernel of
            hypervisors, enabling the selection and building of an entire
            virtual machine. All layers are selectable, end-to-end, allowing a
            single paired-back program as well.
          </p>
          <p>
            Check out the first post{" "}
            <m.route.Link href="/posts">here</m.route.Link>
          </p>
        </section>
      </RootTemplate>
    );
  },
};

const Post = {
  view: () => {
    return (
      <RootTemplate>
        <section>
          <p>
            &emsp; This project is called <b>vm-kit</b>. Without the many
            details and quite simply; You can consider this the linux kernel of
            hypervisors, enabling the selection and building of an entire
            virtual machine. All layers are selectable, end-to-end, allowing a
            single paired-back program as well.
          </p>
          <p>
            &emsp; I have many goals, but one of the primary goals is to
            introduce an open source hypervisor. This will allow for emulation
            similar to that of traditional hypervisors while remaining open
            source. The hardware on which vm-kit will operate will also be open
            source, making it readily available to any manufacturer and
            increasing the longevity of any software built on vm-kit. The cloud
            benefits are quite obvious. So this post won't go in much detail
            about them. This post is to introduce the reader to think beyond the
            traditional program layers.
          </p>
          <p>
            &emsp; Software should work damn it, and it should work forever. I
            can count almost daily how often most technology frustrates me with
            bugs, or incredibly slow software. I would encourage anyone who
            shares this frustration to watch Andrew Kelley’s talk about
            bit-rotting, systems design, and building a program made to last.
            Found <a href="https://www.youtube.com/watch?v=SCLrNqc9jdE">here</a>
          </p>
          <p>
            &emsp; There are a lot of good points in the video, but the main
            point to pick out is building long lasting software. Andrew Kelley
            statically linked the binary, and mentions how the stability of the
            Linux kernel will ensure the success of his longevity goal. However,
            what if we took this concept further by allowing composition from
            hardware down to program.
          </p>
          <p>
            &emsp; Another selling point, is performance. By using the
            hypervisor layer, or machine layer, vm-kit will package an
            incredibly paired down application. Certain parts of the linux
            kernel could be skipped in bundling an application. There would be
            no need to have the slower boundary between kernel and userspace.
            The typically userpsace application could have it's own scheduling
            system all bundled with vm-kit.
          </p>
          <p>
            &emsp; I feel as though this post is light on much I wanted to
            discuss. And probably leaving more questions than answered. So
            before I end up talking more, I will end here; asking the community
            for feedback, and if there is anything you would want to be seen
            done? I’m pretty sure the next post I will do will be around design.
            I believe more goals and ideas I have will come out during that
            session. Please reach out to me at{" "}
            <a href="mailto:community@vm-kit.com">community@vm-kit.com</a>
          </p>
        </section>
      </RootTemplate>
    );
  },
};

const routes = {
  "/": Home,
  "/posts": Post,
};

m.route(document.body, "/", routes);
